export default __webpack_public_path__ + "static/media/brooke_nelson.e94fd7ec.gif";